import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import EventFields from '@jumbo/Dashboards/Events/EventFields';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.eventsPage'} />, link: '/events' },
  { label: <IntlMessages id={'pages.editEventPage'} />, isActive: true },
];

const EditEvent = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.editEventPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <EventFields />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default EditEvent;
